import { createComponent } from '@carvana/merch-components';

export const Container = createComponent('div', {
  className:
    'flex w-full flex-col gap-4xl md:max-w-[1272px] md:flex-row md:gap-2xl lg:gap-9xl'
});

export const HeadingWrapper = createComponent('div', {
  className: 'flex flex-1 flex-col gap-xl'
});

export const Description = createComponent('p', {
  className: 'text-text-default t-body-lg'
});

export const ArticlesWrapper = createComponent('div', {
  className: 'grow md:basis-[550px]'
});
